<template>
  <form
    method="POST"
    class="b-prg b-prg_csrf"
    target="_blank"
    action="/prg/"
  >
    <input
      type="hidden"
      name="csrfmiddlewaretoken"
      :value="csrfToken"
    >

    <input
      type="hidden"
      name="url"
      :value="encodedUrl"
    >
    <button
      v-bind="buttonAttrs"
      type="submit"
    >
      <slot />
    </button>
  </form>
</template>

<script setup lang="ts">
import { getCSRFToken } from 'www/utils'

const props = defineProps<{
  url: string
  buttonAttrs: object
}>()

const csrfToken = getCSRFToken()

const url = props.url.trim()
const encodedUrl = encodeURIComponent(url)
</script>
